// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import CategoryList from '../views/CategoryList.vue';
import AboutUs from '../views/AboutUs.vue';
import ProductDetail from '../views/ProductDetail.vue';
import StoreJoin from '@/views/StoreJoin.vue';

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
  },
  {
    path: '/categories',
    name: 'CategoryList',
    component: CategoryList,
  },
  {
    path: '/about',
    name: 'AboutUs',
    component: AboutUs,
  },
  {
    path: '/product/:id',
    name: 'ProductDetail',
    component: ProductDetail,
  },
  {
    path: '/storeJoin',
    name: 'StoreJoin',
    component: StoreJoin,
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  strict: true,
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 })
});


// export const resetRouter = (): void => {
//   router.getRoutes().forEach((route) => {
//     const { name } = route
//     if (name && !NO_RESET_WHITE_LIST.includes(name as string)) {
//       router.hasRoute(name) && router.removeRoute(name)
//     }
//   })
// }

// export const setupRouter = (app: App<Element>) => {
//   app.use(router)
// }

export default router